$(document).ready(function(){
  $('.block__collection-main-content').each(function(){
    var current_collection = $(this).attr('id');
    var  columnvalue = $('#'+current_collection+' .block__card-product--slider').data('column');
     var  mobilecolumnvalue = $('#'+current_collection+' .block__card-product--slider').data('column-mobile');
    $('#'+current_collection+' .block__section_product-card_man').not('.slick-initialized').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: columnvalue,
      prevArrow: '<button role="button" aria-label="Previous Slide" class="block__section-slick-arrow-coll-main left" aria-label="Previous Slide"><span  class="slick-arrow-collection prev-arrow"><svg width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" fill="#0F0F0F"></path><path d="M15.3927 17.3749L18.7452 14.0224L17.8614 13.1385L13 17.9999L17.8614 22.8612L18.7452 21.9774L15.3927 18.6249H23V17.3749H15.3927Z" fill="white"></path></svg></span></button>',
      nextArrow: '<button role="button" aria-label="Next Slide" class="block__section-slick-arrow-coll-main right" aria-label="Next Slide"><span  class="slick-arrow-collection next-arrow"><svg width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C9.71572 33 3 26.2843 3 18C3 9.71573 9.71572 3 18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33Z" fill="#0F0F0F"/><path d="M20.6073 17.3749L17.2548 14.0224L18.1386 13.1385L23 17.9999L18.1386 22.8612L17.2548 21.9774L20.6073 18.6249H13V17.3749H20.6073Z" fill="white"/></svg></span></button>',      
      slidesToScroll: 1,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1,
     }
      }, 
      {
        breakpoint: 750,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, 
          centerMode: true,
          centerPadding: '20px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1, 
          centerMode: true,
          centerPadding: '40px'
        }
      },
        {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px'
        }
      }
    ]
    }); 
    $(".prev-btn").click(function (event) {
         event.preventDefault();
		$('#'+current_collection+' .block__section_product-card_man').slick("slickPrev");
	});
	$(".next-btn").click(function (event) {
    event.preventDefault();
		$('#'+current_collection+' .block__section_product-card_man').slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$('#'+current_collection+' .block__section_product-card_man').on("afterChange", function (event) {
       event.preventDefault();
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});
  });

// Tag Wise Product Show
$('.block__collection-titletag').click(function(event){
   event.preventDefault();
   
    var data_tag_collection = $(this).attr('data-tag-collection');
    $(this).parents('.block__collection-titletag-main').find('.block__collection-titletag').removeClass('block__collection-active');
    $(this).parents('.block__collection-main-content').find('.block__section_product-card_man').removeClass('block__collection-active').css('display', 'none'); // Remove the class and fade out all subcategories
    $(this).addClass('block__collection-active');
    $(this).closest('.block__collection-main-content').find('.block__card-product--slider').find('[data-tag-collection-product="'+data_tag_collection+'"]').addClass('block__collection-active').css('display', 'block');

    $(this).parents('.block__collection-main-content').find('.block__collection_product-grid-wrapper-banner').removeClass('block__collection-active').css('display', 'none'); // Remove the class and fade out all subcategories
    $(this).addClass('block__collection-active');
    $(this).closest('.block__collection-main-content').find('.block__collection_product-grid-inner').find('[data-tag-collection-product="'+data_tag_collection+'"]').fadeIn(600).addClass('block__collection-active').css('display', 'block');
    $(".block__collection-titletag").removeAttr("tabindex")
    $(".block__collection-titletag").attr("tabindex" , -1 )
    $(this).attr("tabindex" , 0)

     $('.block__collection-main-content').each(function(){
       var current_collection = $(this).attr('id');
       setTimeout(function(){
          $('#'+current_collection+' .block__section_product-card_man').slick('refresh');
        },40);
     });    
    $(this).closest('.block__collection-main-content').find('.block__collection_product-grid-inner').find('[data-tag-collection-product="'+data_tag_collection+'"]').addClass('block__collection-active').css('display', 'block');
      $('.block__section_product-card_man').slick('setPosition');
    $('.swatch_result--otheroptions-tr').slick('setPosition');
      setTimeout(function(){
        equl(".block__section---productcontent--hidespace");
        equl(".block__section---productcontent--button");
        equl(".block__section---productcontent--color");
      },200)   
  });
}); 




